"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPayload = void 0;
/* eslint-disable eqeqeq */
/* eslint-disable no-plusplus */
/* eslint-disable no-await-in-loop */
/* eslint-disable consistent-return */
/* eslint-disable import/prefer-default-export */
var await_timeout_1 = __importDefault(require("await-timeout"));
var conversions_1 = require("../../../../utils/conversions");
var DeviceCharacteristic_1 = require("../../../../common/DeviceCharacteristic");
/**
 * return resolved promises in order
 * @param {*} array
 * @param {*} callback
 */
function asyncForEach(array, callback) {
    return __awaiter(this, void 0, void 0, function () {
        var index;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    index = 0;
                    _a.label = 1;
                case 1:
                    if (!(index < array.length)) return [3 /*break*/, 4];
                    return [4 /*yield*/, callback(array[index], index, array)];
                case 2:
                    _a.sent();
                    // return true when all done
                    if (index == array.length - 1)
                        return [2 /*return*/, true];
                    _a.label = 3;
                case 3:
                    index++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    });
}
var setPayload = function (device, request) { return __awaiter(void 0, void 0, void 0, function () {
    var MAX_DATA_SEND_SIZE, h2ab, payloadChunks, UploadingLoop;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                MAX_DATA_SEND_SIZE = 20;
                h2ab = (0, conversions_1.hexStringToArrayBuffer)("0x".concat(request.backendRequestJsonPayload));
                payloadChunks = (0, conversions_1.splitArrayIntoChunks)(h2ab, MAX_DATA_SEND_SIZE);
                if (!(device.controlCode === 1 || device.controlCode === 2)) return [3 /*break*/, 3];
                return [4 /*yield*/, asyncForEach(payloadChunks, function (chunk) { return __awaiter(void 0, void 0, void 0, function () {
                        var error_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 3, , 4]);
                                    return [4 /*yield*/, device.writeCharacteristicValues(device.profile.DEVICE_MANAGEMENT.characteristics.find(function (c) { return c.name === DeviceCharacteristic_1.DeviceManagementCharacteristics.PAYLOAD; }).uuid, chunk)];
                                case 1:
                                    _a.sent();
                                    return [4 /*yield*/, await_timeout_1.default.set(100)];
                                case 2:
                                    _a.sent();
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_1 = _a.sent();
                                    console.log(error_1);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); }).then(function (res) {
                        console.log(res);
                        return !!res;
                    })];
            case 1:
                UploadingLoop = _b.sent();
                if (!UploadingLoop) return [3 /*break*/, 3];
                return [4 /*yield*/, device.writeCharacteristicValues((_a = device.profile) === null || _a === void 0 ? void 0 : _a.DEVICE_MANAGEMENT.characteristics.find(function (c) { return c.name === DeviceCharacteristic_1.DeviceManagementCharacteristics.CONTROL; }).uuid, Uint8Array.of(3))];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.setPayload = setPayload;
